var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconStarted(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.94 45.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.74,
    y: 18.73,
    width: 4.02,
    height: 12.1,
    rx: 2.01,
    ry: 2.01,
    fill: "#ffba00",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.99,
    y: 21.54,
    width: 4.02,
    height: 9.29,
    rx: 2.01,
    ry: 2.01,
    fill: "#00c880",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.36,
    y: 12.93,
    width: 4.02,
    height: 17.91,
    rx: 2.01,
    ry: 2.01,
    fill: "#1696e5",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.61,
    y: 16.39,
    width: 4.02,
    height: 14.45,
    rx: 2.01,
    ry: 2.01,
    fill: "#1696e5",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.3,17.48h-1.37c-.28,0-.5.22-.5.5s.22.5.5.5h.02l-5.86,4.97-6.31-9.1c-.08-.12-.21-.2-.36-.21-.14-.02-.29.03-.39.13l-6.62,6.11c-.2.19-.22.5-.03.71.19.2.5.22.71.03l6.2-5.72,6.3,9.08c.08.12.21.19.35.21.02,0,.04,0,.06,0,.12,0,.23-.04.32-.12l6.49-5.5v.42c0,.28.22.5.5.5s.5-.22.5-.5v-1.51c0-.28-.22-.5-.5-.5Z",
    fill: "#192c62",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.12.63l-3.15,1.24h-4.28c-2.53,0-4.59,2.06-4.59,4.59s2.06,4.59,4.59,4.59h.98v2.13c0,1.08.88,1.95,1.95,1.95s1.95-.88,1.95-1.95v-1.89l2.55,1c.06.02.12.03.18.03.1,0,.2-.03.28-.09.14-.09.22-.25.22-.41V1.1c0-.17-.08-.32-.22-.41-.14-.09-.31-.11-.46-.05Zm-4.5,13.5c-.52,0-.95-.43-.95-.95v-2.13h1.9v2.13c0,.53-.43.95-.95.95Zm4.19-3.04l-2.54-1s0,0-.01,0h0s-.09-.03-.14-.03c-.01,0-.03,0-.04,0h-4.38c-1.98,0-3.59-1.61-3.59-3.59s1.61-3.59,3.59-3.59h4.38c.06,0,.12-.01.18-.04l2.55-1v9.26Z",
    fill: "#192c62",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.7,2.74s.09,0,.13-.02l3.74-1.04c.27-.07.42-.35.35-.62-.07-.27-.35-.42-.62-.35l-3.74,1.04c-.27.07-.42.35-.35.62.06.22.26.37.48.37Z",
    fill: "#192c62",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.58,11.24l-3.74-1.04c-.26-.07-.54.08-.62.35-.07.27.08.54.35.62l3.74,1.04s.09.02.13.02c.22,0,.42-.15.48-.37.07-.27-.08-.54-.35-.62Z",
    fill: "#192c62",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.7,6.9h3.74c.28,0,.5-.22.5-.5s-.22-.5-.5-.5h-3.74c-.28,0-.5.22-.5.5s.22.5.5.5Z",
    fill: "#192c62",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.57,1.03v10.86c0,.73-.69,1.23-1.34.96l-1.73-.71V.78l1.73-.71c.64-.26,1.34.24,1.34.96Z",
    fill: "#00c880",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.47,44.05l-.13.12c-1.54,1.54-4.03,1.54-5.57,0l-7.72-7.72c2.35-1.37,4.38-3.24,5.93-5.46l7.49,7.49c1.53,1.53,1.53,4.03,0,5.57Z",
    fill: "#1696e5",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.36,20.3c0,3.97-1.24,7.66-3.38,10.69-1.55,2.22-3.58,4.09-5.93,5.46-2.76,1.61-5.96,2.53-9.37,2.53C8.38,38.98,0,30.6,0,20.3S8.38,1.62,18.68,1.62h.35c.28.01.5.24.49.51,0,.28-.25.5-.51.49h-.33C8.93,2.62,1,10.55,1,20.3s7.93,17.68,17.68,17.68,17.68-7.93,17.68-17.68c0-1.88-.29-3.74-.87-5.51-.09-.26.05-.54.31-.63.27-.08.55.06.64.32.61,1.87.92,3.83.92,5.82Z",
    fill: "#192c62",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.87,24.54c-.22,0-.43-.15-.48-.38-.32-1.26-.48-2.56-.48-3.87,0-7.89,5.89-14.61,13.7-15.63.63-.08,1.53-.13,2.29-.13.28,0,.5.22.5.5s-.22.5-.5.5c-.73,0-1.58.05-2.16.13-7.31.96-12.83,7.25-12.83,14.64,0,1.22.15,2.44.45,3.62.07.27-.1.54-.36.61-.04,0-.08.01-.12.01Z",
    fill: "#192c62",
    strokeWidth: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStarted);
export default __webpack_public_path__ + "static/media/icon-started.30390b07535429640624865059ffcda9.svg";
export { ForwardRef as ReactComponent };